import { render, staticRenderFns } from "./DraggableMagazineArticle0013.vue?vue&type=template&id=2a04451f&"
import script from "./DraggableMagazineArticle0013.vue?vue&type=script&lang=js&"
export * from "./DraggableMagazineArticle0013.vue?vue&type=script&lang=js&"
import style0 from "./DraggableMagazineArticle0013.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports